// Options (variants) as editable string rows, and back. Shared by the draft form and the
// "add as option of an existing product" dialog. Empty string = not set (null), never 0.

const NUMERIC = ['mrp', 'eyantraPurchasePrice', 'stockQty'];
const LABELS = { mrp: 'MRP', eyantraPurchasePrice: 'EPP', stockQty: 'stock' };

const str = (v) => (v === null || v === undefined ? '' : String(v));

export const emptyRow = (prefill = {}) => ({
  color: '', colorHex: '', size: '', mrp: '', eyantraPurchasePrice: '', sku: '', stockQty: '', imageId: '',
  ...Object.fromEntries(Object.entries(prefill).map(([k, v]) => [k, str(v)])),
});

export const toRows = (variants) => (variants || []).map((v) => emptyRow(v));

export const fromRows = (rows) => (rows || []).map((r) => {
  const t = (k) => (r[k] ?? '').trim();
  const num = (k) => (t(k) === '' ? null : Number(t(k)));
  return {
    color: t('color') || null,
    colorHex: t('colorHex') || null,
    size: t('size') || null,
    mrp: num('mrp'),
    eyantraPurchasePrice: num('eyantraPurchasePrice'),
    sku: t('sku') || null,
    stockQty: t('stockQty') === '' ? null : Math.trunc(Number(t('stockQty'))),
    imageId: t('imageId') === '' ? null : Number(t('imageId')),
  };
});

/** A message for the first unparseable number in the rows, or null. */
export const rowsError = (rows) => {
  for (let i = 0; i < (rows || []).length; i += 1) {
    const bad = NUMERIC.find((k) => (rows[i][k] ?? '').trim() !== '' && !Number.isFinite(Number(rows[i][k])));
    if (bad) return `Option ${i + 1}: the ${LABELS[bad]} "${rows[i][bad]}" isn't a number.`;
  }
  return null;
};

/** A single unambiguous value from a comma list ("Black" → "Black", "Black, Olive" → ""). */
export const single = (commaList) => (commaList && !commaList.includes(',') ? commaList.trim() : '');
